module.exports = __webpack_public_path__ + "static/img/erweima.dd04a7ec.png";